export const c_progress_stepper__step_title_m_help_text_hover_Color = {
  "name": "--pf-c-progress-stepper__step-title--m-help-text--hover--Color",
  "value": "#a30000",
  "var": "var(--pf-c-progress-stepper__step-title--m-help-text--hover--Color)"
};
export default c_progress_stepper__step_title_m_help_text_hover_Color;